import { userCanAccessFds } from './utils.js';

const requirements = {
  requiredUserPermissions: ['settlement-internal', 'settlement-view-and-edit'],
};

const verifier = () => {
  return userCanAccessFds();
};

export { requirements, verifier };
